// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/20250410173632/css/" + chunkId + "." + {"766":"9d6cd5f8","772":"3a929a13","941":"1caaf122"}[chunkId] + ".chunk.css";
};